export { WithBlockquoteVariation as default } from './WithBlockquoteVariation';
